export const translations = {
	nav: {
		title: 'Navigation',
		app: 'Spendenbescheinigung',
	},
	footer: {
		poweredBy: 'Erstellt von',
		copyright: '© {{year}} WorldCoo. Alle Rechte vorbehalten.',
		termsAndConditions: 'Allgemeine Geschäftsbedingungen',
		privacyPolicy: 'Datenschutzrichtlinie',
	},
	categories: {
		basicNeeds: 'Wasser und Energie',
		humanRights: 'Menschenrechte',
		education: 'Bildung',
		emergency: 'Notfälle',
		feeding: 'Hunger und Ernährungssicherheit',
		environment: 'Umwelt',
		habitat: 'Wohnen und Armut',
		health: 'Gesundheit',
	},
	statistics: {
		campaigns: 'Kampagnen',
		donations: 'Spenden',
		collected: 'Gesammelt',
		collectedFromBudget: 'Ziel von {{budget}}',
	},
	filters: {
		year: 'Jahr',
		state: 'Status',
		cause: 'Zweck',
		active: 'Aktiv',
		finished: 'Beendet',
		default: 'Standard',
		toggle: '{{value}} umschalten',
	},
	actions: {
		close: 'Schließen',
		search: 'Alles durchsuchen',
		filter: 'Filtern',
		viewCampaign: 'Kampagne ansehen',
		makeDonation: 'Spende tätigen',
		donate: 'Spenden',
		selectLanguage: 'Sprache auswählen',
		backToHome: 'Zurück zur Startseite',
		funded: 'Finanziert',
		clear: 'Filter löschen',
		apply: 'Anwenden',
		goBack: 'Zurück',
		previous: 'Vorherige',
		next: 'Nächste',
	},
	portal: {
		heroButton: 'Jetzt spenden',
		campaigns: {
			title: 'Kampagnen',
			description: 'Entdecken Sie unsere Initiativen und wählen Sie die Sache, die Sie am meisten inspiriert',
			notFound: 'Keine Kampagnen',
		},
		campaignFunded: 'Kampagne finanziert',
		percentageFunded: '{{percentage}}% Finanziert',
		aCampaignFrom: 'Eine Kampagne von: {{ngoName}}',
		beneficiaries: 'Begünstigte',
		directBeneficiaries: '{{count}} direkt',
		indirectBeneficiaries: '{{count}} indirekt',
		sdgs: {
			title: 'Ziele für nachhaltige Entwicklung',
			1: 'Keine Armut',
			2: 'Kein Hunger',
			3: 'Gesundheit und Wohlergehen',
			4: 'Hochwertige Bildung',
			5: 'Geschlechtergleichheit',
			6: 'Sauberes Wasser und Sanitäreinrichtungen',
			7: 'Bezahlbare und saubere Energie',
			8: 'Menschenwürdige Arbeit und Wirtschaftswachstum',
			9: 'Industrie, Innovation und Infrastruktur',
			10: 'Weniger Ungleichheiten',
			11: 'Nachhaltige Städte und Gemeinden',
			12: 'Nachhaltige/r Konsum und Produktion',
			13: 'Maßnahmen zum Klimaschutz',
			14: 'Leben unter Wasser',
			15: 'Leben an Land',
			16: 'Frieden, Gerechtigkeit und starke Institutionen',
			17: 'Partnerschaften zur Erreichung der Ziele',
		},
	},
	faq: {
		title: 'Häufig gestellte Fragen',
		description: 'Antworten auf die häufigsten Fragen unserer Spender.',
	},
	campaign: {
		objectives: 'Kampagnenziele',
		description: 'Beschreibung',
		activities: 'Aktivitäten',
		beneficiaries: 'Wer profitiert?',
		updatesAndLinks: 'Weitere Informationen und Links',
		from: 'Von:',
		until: 'Bis:',
	},
	campaigns: {
		notTranslated: 'Dieses Projekt ist in deiner Sprache noch nicht verfügbar.',
	},
	placeholders: {
		amount: 'Anderer Betrag',
	},
	donate: {
		title: 'Spende jetzt',
		details: {
			title: 'Geben Sie Ihre Daten ein, um fortzufahren',
			subtitle:
				'Vervollständigen Sie Ihre Daten, um Ihre Spende abzuschließen. Sie können hier auch Ihre Steuerbescheinigung anfordern.',
		},
		certificate: {
			title: 'Erhalten Sie bis zu {{amount}} zurück',
			subtitle:
				'Bestätigen Sie Ihre Spende mit einem Klick und sie wird automatisch in Ihrem Steuererklärungsentwurf erscheinen.',
		},
	},
	errors: {
		required: 'Dieses Feld ist erforderlich',
		invalidExtref: 'Der Code ist ungültig, er muss diesem Format entsprechen: {{format}}',
		email: 'Die E-Mail-Adresse ist falsch formatiert.',
		emailAlreadyExists: 'Diese E-Mail wird bereits verwendet.',
		password: 'Ihr Passwort muss mindestens 6 Zeichen lang sein.',
		confirmationCode: 'Bitte geben Sie den Bestätigungscode ein.',
		documentType: 'Ungültiger Dokumenttyp',
		termsAndConditions: 'Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren',
		amount: 'Bitte wählen Sie einen gültigen Betrag aus oder geben Sie ihn ein.',
		signIn: 'Fehler beim Anmelden',
		emailsDoNotMatch: 'E-Mail-Adressen stimmen nicht überein.',
		passwordsDoNotMatch: 'Passwörter stimmen nicht überein.',
		imageFormat: 'Bitte legen Sie eine Bilddatei ab',
		camera: 'Zugriff auf die Kamera nicht möglich. Bitte stellen Sie sicher, dass Sie die Berechtigung erteilt haben.',
		expiredCode: 'Der Code ist abgelaufen.',
		codeMismatch: 'Der Code ist falsch. Bitte versuchen Sie es erneut.',
		notAuthorized: 'Falsche Zugangsdaten. Bitte versuchen Sie es erneut.',
		userDoesNotExist: 'Der Benutzer existiert nicht.',
		userNotConfirmed: 'Benutzer nicht bestätigt. Bitte bestätigen Sie zuerst Ihre E-Mail-Adresse.',
		userAlreadyConfirmed: 'Der Benutzer wurde bereits bestätigt.',
		documentNumberExists: 'Die Dokumentennummer wird bereits verwendet.',
		limitExceeded: 'Sie haben das Versuchslimit erreicht. Bitte versuchen Sie es später erneut.',
		invalidPassword:
			'Das Passwort ist ungültig, es muss mindestens 6 Zeichen lang sein und darf keine Leerzeichen enthalten.',
		captchaFailed: 'CAPTCHA verification failed. Please try again.',
		internal:
			'Entschuldigung, es ist ein Problem aufgetreten, unser Team wurde bereits informiert, bitte versuchen Sie es später erneut.',
	},
	documentTypes: {
		id: 'Personalausweis',
		passport: 'Reisepass',
		taxId: 'Steueridentifikation',
		nie: 'NIE',
		others: 'Andere',
	},
	labels: {
		code: 'Code',
		email: 'E-Mail',
		repeatEmail: 'E-Mail wiederholen',
		password: 'Passwort',
		confirmPassword: 'Passwort bestätigen',
		amount: 'Spendenbetrag',
		documentType: 'Dokumenttyp',
		documentNumber: 'Dokumentnummer',
		name: 'Name',
		lastName: 'Nachname',
		streetName: 'Straßenname',
		streetNumber: 'Nummer',
		additionalInfo: 'Zusätzliche Informationen',
		postalCode: 'Postleitzahl',
		city: 'Stadt',
		country: 'Land',
		region: 'Region',
		province: 'Provinz',
		certificate: 'Ich möchte eine Spendenbescheinigung erhalten',
		termsAndConditions1:
			'Diese Informationen werden nur mit den empfangenden Organisationen geteilt, um die entsprechende Spendenbescheinigung zu erstellen. Lesen Sie die ',
		termsAndConditions2: 'Allgemeinen Geschäftsbedingungen',
		language: 'Sprache',
		newsletter:
			'Abonnieren Sie, um über die Anliegen, die wir unterstützen, die Projekte, die wir finanzieren, und die Menschen, die wir weltweit stärken, auf dem Laufenden zu bleiben.',
	},
	checkout: {
		title: 'Zahlungsmethode',
	},
	recaptcha: {
		description: 'geschützt durch reCAPTCHA.',
		privacy: 'Datenschutz',
		terms: 'Bedingungen',
	},
	thanks: {
		title: 'Danke\n für Ihre Spende!',
		description:
			'In Kürze erhalten Sie eine Bestätigungs-E-Mail mit allen Details. Gemeinsam bauen wir eine bessere Zukunft!',
	},
	termsAndConditions: {
		title: 'Datenschutzbedingungen',
		labelText: 'Ich habe gelesen, verstanden und akzeptiere die Bedingungen des ',
		labelLink: 'Datenschutzes von {{name}}',
		accept: 'Ich habe gelesen, verstanden und akzeptiere',
		responsible: {
			title: 'Verantwortlich',
			description: 'WORLDCOO S.L.',
		},
		purpose: {
			title: 'Zweck',
			description:
				'Verwaltung der Geschäftsbeziehung in allen Bereichen, sowie Ihre Spende und Ihr Zertifikatsantrag, und der Versand von Werbekommunikation auf elektronischem Weg.',
			descriptionNgo:
				'Mittelbeschaffung für NGO-Projekte, Sie über die NGO und die Entwicklung des Projekts, für das Sie Geld gespendet haben, auf dem Laufenden zu halten und Steuerabzugszertifikate auszustellen.',
		},
		legitimacy: {
			title: 'Legitimität',
			description: 'Die Rechtsgrundlage für die Verarbeitung Ihrer Daten ist die Einholung Ihrer Einwilligung.',
		},
		recipients: {
			title: 'Empfänger',
			description:
				'Daten werden nicht an Dritte weitergegeben, es sei denn, es besteht eine gesetzliche Verpflichtung dazu.',
		},
		rights: {
			title: 'Rechte',
			description:
				'Sie haben das Recht auf Zugang, Berichtigung und Löschung von Daten sowie andere Rechte, wie in den zusätzlichen Informationen erläutert.',
		},
		additionalInfo: {
			title: 'Zusätzliche Informationen',
			description:
				'Sie können zusätzliche und detaillierte Informationen zum Datenschutz auf unserer Seite <a href="https://www.worldcoo.com/gdpr">Web</a> einsehen oder sich an <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a> wenden.',
			descriptionNgo:
				'Sie können die zusätzlichen und detaillierten Informationen zum Datenschutz auf der Website jeder NGO einsehen.\n\n<b>{{ngoName}}</b>',
		},
	},
};
